var React = require('react');

function Cluster (props) {
    return React.createElement("svg",props,React.createElement("g",null,[React.createElement("polygon",{"fill":"none","stroke":"currentColor","strokeWidth":"0.5","strokeLinecap":"round","strokeLinejoin":"round","strokeMiterlimit":"10","points":"\n\t\t1.6,4.3 1.6,11.7 8,15.4 14.4,11.7 14.4,4.3 8,0.6 \t","key":0}),React.createElement("polygon",{"fill":"none","stroke":"currentColor","strokeWidth":"0.5","strokeLinecap":"round","strokeLinejoin":"round","strokeMiterlimit":"10","points":"\n\t\t4.5,6 4.5,10 8,12 11.5,10 11.5,6 8,4 \t","key":1}),React.createElement("polygon",{"fill":"none","stroke":"currentColor","strokeWidth":"0.5","strokeLinecap":"round","strokeLinejoin":"round","strokeMiterlimit":"10","points":"\n\t\t6.8,7.3 6.8,8.7 8,9.3 9.2,8.7 9.2,7.3 8,6.7 \t","key":2})]));
}

Cluster.displayName = "Cluster";

Cluster.defaultProps = {"version":"1.1","id":"Layer_1","x":"0px","y":"0px","viewBox":"0 0 16 16","enableBackground":"new 0 0 16 16","xmlSpace":"preserve"};

module.exports = Cluster;

Cluster.default = Cluster;



//////////////////
// WEBPACK FOOTER
// ../icon/src/icons/cluster.svg
// module id = ../icon/src/icons/cluster.svg
// module chunks = 0